import { HighLightText } from "../../utils/HighLightText";

interface SubheaderProps {
  clients: string[];
  partner: string;
  deliverable: string;
  subheaderImage: string;
}

export const Subheader: React.FC<SubheaderProps> = ({
  clients,
  partner,
  deliverable,
  subheaderImage,
}) => {
  return (
    <div className="w-full flex lg:flex-row flex-col justify-between items-center lg:gap-16 gap-6 lg:py-24">
      <img src={subheaderImage} alt="man" className="w-full block lg:hidden" />

      <div className="lg:w-[40%] w-full flex flex-row justify-between lg:gap-16 md:gap-8 gap-4">
        <div className=" flex flex-col max-w-1/4 items-start gap-4">
          <p className="lg:text-2xl md:text-xl text-lg font-gilroy-bold"> Client </p>
          
          <div>
            {clients?.map((client, index) => (
              <p key={index} className="lg:text-xl md:text-xl text-lg capitalize lg:leading-[1] font-gilroy-light">
                {client}
              </p>
            ))}
          </div>
        </div>

        <div className=" flex flex-col lg:items-start gap-4 max-w-1/4">
          <p className="lg:text-2xl md:text-xl text-lg font-gilroy-bold"> Partner Agency </p>
          <p className="lg:text-xl text-lg capitalize font-gilroy-light">{partner}</p>
        </div>
      </div>

      <img src={subheaderImage} alt="man" className="w-[30%] lg:my-0 my-8 lg:block hidden rounded-[20px]" />

      <div className="lg:w-[40%] w-full flex flex-col justify-between items-start gap-4 py-2">
        <p className="lg:text-2xl md:text-xl text-lg font-gilroy-bold"> Deliverable </p>
        <p className="lg:text-xl md:text-2xl text-lg  font-gilroy-light">
          {HighLightText(deliverable, "font-gilroy-bold flex")}
        </p>
      </div>
    </div>
  );
};
